<template>
    <v-dialog
        v-model="display"
        width="450">
        <v-card>
            <v-card-title>{{ title ? title : $t("alert_title") }}</v-card-title>
            <v-card-text><span v-html="content"></span></v-card-text>
            <v-card-actions>
                <v-btn :loading="loading" depressed color="primary" @click="submit" v-if="callback">{{ $t('btn_confirm') }}</v-btn>
                <v-btn text @click="display = false">{{ $t('cancel_btn') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "PAlert",
    props: {
        title: {
            type: String
        },
        content: String,
        value: {
            type: Boolean,
            default: false
        },
        callback: {
            type: Function
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val)
            }
        }
    },
    methods: {
        submit() {
            this.display = false;
            this.callback();
        },
        shortcuts(e) {
            if(e.keyCode === 13) this.submit();
        },
    }
}
</script>